var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"holder"}},[_c('div',{staticClass:"border"},[_c('img',{attrs:{"src":require("@/assets/wa_logo.png"),"alt":"logo"}}),_c('button',{on:{"click":_vm.direct_to_wa}},[_vm._v("Scrivici su WhatsApp")])])])}
var staticRenderFns = []

export { render, staticRenderFns }